export interface ChargingRange {
    id: string;
    minAmount: number;
    maxAmount: number;
    charge: number;
    chargeType: 'fixed' | 'percentage';
}

export interface TransactionTypeCharging {
    transactionType: string;
    subType?: string;
    ranges: ChargingRange[];
    enabled: boolean;
}

export interface ChargingConfiguration {
    companyId: string;
    configurations: TransactionTypeCharging[];
    lastModified: string;
    modifiedBy: string;
}

export interface TransactionType {
    type: string;
    label: string;
    subTypes: string[];
}

export interface ChargeCalculation {
    charge: number;
    enabled: boolean;
}

export const CHARGE_TYPE_FIXED = 'fixed';
export const CHARGE_TYPE_PERCENTAGE = 'percentage';

export const TRANSACTION_TYPE_FUND_TRANSFER = 'fund_transfer';
export const TRANSACTION_TYPE_SOA = 'soa';
export const TRANSACTION_TYPE_BILL_PAYMENT = 'bill_payment';
export const TRANSACTION_TYPE_ATM = 'atm_withdrawal';
export const TRANSACTION_TYPE_BALANCE = 'balance_inquiry';

export const SUB_TYPE_SAME_BANK = 'same_bank';
export const SUB_TYPE_OTHER_BANK = 'other_bank';
export const SUB_TYPE_INTERNATIONAL = 'international';